<!--
  ~ Copyright 2022. NXGN Management, LLC. All Rights Reserved.
  -->

<div class="modal-content border-0">
  <div class="modal-header">
    <div class="modal-title" id="exampleModalLongTitle">{{ title }}</div>
    <button
      type="button"
      class="close btn-close"
      data-dismiss="modal"
      aria-label="Close"
      (click)="close()"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <form [formGroup]="partnersFormGroup" (submit)="okBasedOnAction(this.action)">
    <div class="modal-body">
      <table class="table table-bordered table-striped" *ngIf="!isAdd()">
        <tbody>
          <tr>
            <td>{{ partner.id }}</td>
            <td>{{ partner.username }}</td>
            <td *ngIf="!partner.showPassword" (click)="showPassword(partner)">
              Click to show password
            </td>
            <td *ngIf="partner.showPassword" (click)="showPassword(partner)">
              {{ partner.password }}
            </td>
          </tr>
        </tbody>
      </table>
      <div id="viewModalContent" class="container-fluid col-md-12">
        <fieldset *ngIf="isAddOrEdit()">
          <div class="form-group fieldIsRequired">
            <label class="col-md-4 control-label" for="username"
              >Username</label
            >
            <div class="col-md-12">
              <input
                class="form-control"
                [ngClass]="{
                  'is-invalid':
                    partnersFormGroup.controls.username.invalid &&
                    partnersFormGroup.controls.username.touched
                }"
                type="text"
                formControlName="username"
                id="username"
              />
              <div
                class="formValidationMessage mt-1"
                role="alert"
                *ngIf="
                  partnersFormGroup.controls.username.invalid &&
                  partnersFormGroup.controls.username.touched
                "
              >
                <div
                  class="text-danger"
                  *ngIf="partnersFormGroup.controls.username.errors?.required"
                >
                  Field is required.
                </div>
                <div
                  class="text-danger"
                  *ngIf="partnersFormGroup.controls.username.errors?.maxlength"
                >
                  Max length is 25
                </div>
                <div
                  class="text-danger"
                  *ngIf="
                    partnersFormGroup.controls.username.errors?.userNameExists
                  "
                >
                  This partner already exists. Please enter a different
                  username.
                </div>
              </div>
            </div>
          </div>
        </fieldset>
      </div>
    </div>
    <div class="modal-footer">
      <button
        type="button"
        class="btn btn-light"
        (click)="close()"
        data-dismiss="modal"
      >
        Close
      </button>
      <button
        type="submit"
        [disabled]="!partnersFormGroup.valid || actionInProgress"
        class="btn"
        [ngClass]="{
          'btn-primary': isAddOrEdit() || isResetPassword(),
          'btn-danger': isRemove()
        }"
      >
        <span
          *ngIf="actionInProgress"
          class="spinner-border spinner-border-sm"
          role="status"
          aria-hidden="true"
        ></span>
        <span *ngIf="isEdit() && !actionInProgress">
          <fa-icon [icon]="faEditPencil"></fa-icon>
        </span>
        <span *ngIf="isRemove() && !actionInProgress" class="oi oi-x"></span>
        {{ getButtonName() }}
      </button>
    </div>
  </form>
</div>
